import { DEFAULT_ROUTES } from '@mais-retorno-front/constants/routes';
import { IFeeds } from '@mais-retorno-front/models/feed.model';

export class FormatContentToFeedsUseCase {
  constructor() {}

  execute(feedContents: IFeeds[], contentType: string): string {
    const feed = `<?xml version='1.0' encoding='UTF-8'?>
    <rss xmlns:dc="http://purl.org/dc/elements/1.1/" xmlns:atom="http://www.w3.org/2005/Atom" xmlns:media="http://search.yahoo.com/mrss/"  version="2.0">
      <channel>
        <title>Mais Retorno | Notícias do Mercado Financeiro, Economia e Investimentos</title>
        <link>https://maisretorno.com</link>
        <description>RSS dá Mais Retorno. Acesse ferramentas e informações gratuitas de alto nível sobre Comparação de Fundos de Investimentos, Renda Fixa e Renda Variável. Conte com a gente para acelerar o resultado dos seus investimentos!</description>
        <language>pt-BR</language>
        <copyright>® Mais Retorno / Todos os direitos reservados</copyright>
        <atom:link href="https://maisretorno.com/api/nextjs/feed/${contentType}" rel="self" type="application/rss+xml" />
        <image>
          <url>https://maisretorno.com/assets/logo-mais-retorno-google-news-60x60.png</url>
          <title>Mais Retorno</title>
          <link>https://maisretorno.com/</link>
          <width>60</width>
          <height>60</height>
        </image>
          ${feedContents
            .map(
              ({
                content,
                publishedAt,
                thumbnail,
                title,
                url,
                author,
                contentCategories,
              }) => {
                return `
                <item>
                  <title><![CDATA[${title}]]></title>
                  <link>${url}</link>
                  <guid isPermaLink="true">${url}</guid>
                  <pubDate>${publishedAt}</pubDate>
                  ${
                    author
                      ? `<dc:creator><![CDATA[${author}]]></dc:creator>`
                      : ''
                  }                  
                  <description><![CDATA[<img src="${
                    thumbnail?.url
                  }?w=1200&#038;h=675&#038;crop=1"/><br />]]>${content}</description>
                  <media:content url="${
                    thumbnail?.url
                  }?w=1200&#038;h=675&#038;crop=1" medium="image" />
                  <enclosure url="${process.env.NEXT_PUBLIC_DOMAIN}${
                  DEFAULT_ROUTES.nextjsApiBase
                }/resize-image?src=${
                  thumbnail?.url
                }&#038;w=1200&#038;h=675" length="166756" type="image/jpeg" />
                  <category>${contentCategories}</category>
                  <source url="https://maisretorno.com">Mais Retorno</source>
                </item>
              `;
              }
            )
            .join('')}
      </channel>
    </rss>
  `;

    return feed;
  }
}
